document.addEventListener('deployer:update-prices', function (event) {
  const { variant, that, element } = event.detail;
  const quantityInput = document.querySelector('[data-bundle-product]');

  const priceUpdaterCallback = (isCalledFromBundle = false) => {
    const currentQuantity = that.productForm.quantityInputs[that.productForm.quantityInputs.length - 1].value;

    let price;
    let comparePrice;
    let stickerPrice;
    let stickerComparePrice;

    if (isCalledFromBundle) {
      const bundlePrices = ProductPageBundleAction.calculateBundleProductDiscount(variant, currentQuantity);
      price = bundlePrices.price;
      comparePrice = bundlePrices.comparePrice;

      const bundleStickerPrices = ProductPageBundleAction.calculateBundleStickerDiscount(variant, currentQuantity);
      stickerPrice = bundleStickerPrices.price;
      stickerComparePrice = bundleStickerPrices.comparePrice;
    } else {
      const standardPrices = ProductPagePriceUpdater.calculateProductDiscount(variant, currentQuantity);
      price = standardPrices.price;
      comparePrice = standardPrices.comparePrice;

      const stickerPrices = ProductPagePriceUpdater.calculateStickerDiscount(variant, currentQuantity);
      stickerPrice = stickerPrices.price;
      stickerComparePrice = stickerPrices.comparePrice;
    }

    let discountPercentage = 0;

    function compareAtPriceAcceptance(price, comparePrice) {
      if (comparePrice === null || comparePrice === undefined || comparePrice === price || comparePrice === 0) {
        return false;
      } else {
        return price < comparePrice;
      }
    }

    if (isCalledFromBundle && compareAtPriceAcceptance(variant.price, variant.compare_at_price) === true) {
      discountPercentage = percentagePriceAndCompareAndQuantity(variant, currentQuantity);
    } else if (isCalledFromBundle && compareAtPriceAcceptance(variant.price, variant.compare_at_price) === false) {
      discountPercentage = percentageByQuantity(currentQuantity).discountPercentage;
    } else if (!isCalledFromBundle && compareAtPriceAcceptance(variant.price, variant.compare_at_price) === true) {
      discountPercentage = percentagePriceAndCompare(price, comparePrice);
    } else {
      discountPercentage = 0;
    }

    ProductPageUIUpdater.updateDiscountSticker(stickerPrice, stickerComparePrice, discountPercentage);
    ProductPageUIUpdater.updatePriceInButtons(element, price, comparePrice, variant);
    ProductPageUIUpdater.updateKlaviyoButton(variant.available);

    const productPriceWrap = document.querySelector('.product__price__wrap');
    const productPrice = productPriceWrap.querySelector('span[data-product-price]');
    const productComparePrice = productPriceWrap.querySelector('[data-compare-price]');

    productPriceWrap ? ProductPageUIUpdater.updatePricesTopProductPage(productPrice, productComparePrice, price, comparePrice) : null;
  };

  let priceUpdaters = [];
  let multiplicators = document.querySelectorAll('.culottes-multiplicator__container .unit-culotte');  
  
  multiplicators.forEach((element) => {
    priceUpdaters.push(element)
  });
  priceUpdaters.push(document.querySelector('.quantity__plus'));
  priceUpdaters.push(document.querySelector('.quantity__minus'));

  if (quantityInput.dataset.bundleProduct == 'true') {
    priceUpdaterCallback(true);

    for (let listener of priceUpdaters) {
      if (listener) {
        addListenerToElement(listener, 'click', function () {
          priceUpdaterCallback(true);
        });
      }
    }
  } else {
    priceUpdaterCallback(false);
    addListenerToElement(document.querySelector('.quantity__plus'), 'click', function () {
      priceUpdaterCallback(false);
    });
    addListenerToElement(document.querySelector('.quantity__minus'), 'click', function () {
      priceUpdaterCallback(false);
    });
  }

  const bundleBuyXGety = document.querySelectorAll('buy-x-get-y');
  if (bundleBuyXGety.length === 0) return;

  const bxgyListeners = [document.querySelectorAll('.bxgy__quantity-plus'), document.querySelectorAll('.bxgy__quantity-minus')];

  if (quantityInput.dataset.bundleProduct == 'true') {
    for (let listener of bxgyListeners) {
      if (listener) {
        addListenersToElements(listener, 'click', function () {
          priceUpdaterCallback(true);
        });
      }
    }
  } else {
    for (let listener of bxgyListeners) {
      if (listener) {
        addListenersToElements(listener, 'click', function () {
          priceUpdaterCallback(false);
        });
      }
    }
  }

  document.querySelectorAll('buy-x-get-y').forEach(function (element2) {
    addListenerToElement(element2, 'bxgy:selectedElement', () => {
      const selectElements = element2.querySelectorAll('.bxgy__product-options select');
      selectElements.forEach(function (select) {
        selectMatchingOption(select.dataset.optionName, select.value);
      });

      const currentQuantity = that.productForm.quantityInputs[that.productForm.quantityInputs.length - 1].value;
      const { price, comparePrice } = ProductPagePriceUpdater.calculateProductDiscount(variant, currentQuantity);
      const { price: stickerPrice, comparePrice: stickerComparePrice } = ProductPagePriceUpdater.calculateStickerDiscount(variant, currentQuantity);

      const discountPercentage = percentageByQuantity(currentQuantity).discountPercentage;
      ProductPageUIUpdater.updateDiscountSticker(stickerPrice, stickerComparePrice, discountPercentage);

      const productPriceWrap = document.querySelector('.product__price__wrap');
      const productPrice = productPriceWrap.querySelector('span[data-product-price]');
      const productComparePrice = productPriceWrap.querySelector('[data-compare-price]');

      if (productPriceWrap) {
        ProductPageUIUpdater.updatePricesTopProductPage(productPrice, productComparePrice, price, comparePrice);
      }

      if (element2.classList.contains('selected')) {
        ProductPageUIUpdater.updatePricesInBuyXgetY(
          price,
          comparePrice,
          element2.querySelector('.bxgy__product-price'),
          element2.querySelector('.bxgy__product-compare-at-price'),
        );
      }
      element2.updateFakeComparePrice(variant);
    });

    const bxgySelectElements = element.querySelectorAll('.bxgy__product-options select');
    bxgySelectElements.forEach((selector) => {
      selector.addEventListener('change', () => {
        const dataOption = selector.dataset.optionName;
        const optionValue = selector.value;
        selectMatchingOption(dataOption, optionValue);

        const currentQuantity = that.productForm.quantityInputs[that.productForm.quantityInputs.length - 1].value;
        const { price, comparePrice } = ProductPagePriceUpdater.calculateProductDiscount(variant, currentQuantity);

        ProductPageUIUpdater.updatePricesInBuyXgetY(
          price,
          comparePrice,
          element.querySelector('.bxgy__product-price'),
          element.querySelector('.bxgy__product-compare-at-price'),
        );

        const formWrapper = document.querySelector('[data-form-wrapper]');
        const quantitySelector = element.querySelector('.bxgy__quantity-selector');
        quantitySelector.classList.toggle('bxgy__quantity-selector-soldout', formWrapper.classList.contains('variant--soldout'));

        element2.updateFakeComparePrice(variant);
      });
    });
  });
});
